import { ChevronLeftIcon } from '@heroicons/react/outline';
import { Button } from 'antd';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import { IBM_Plex_Sans } from 'next/font/google';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

import Renderer from '../../../components/ResourcesPage/Editor/Reader';
import ButtonDefault, {
  ButtonVariants,
} from '../../../components/shared/basic/button';
import { formateErrorObject } from '../../../components/shared/formateErrorObject';
import CustomLoader from '../../../components/shared/Loading';
import { notify } from '../../../components/shared/notify';
import { getResultData } from '../../../services/personalityTest';

const ibmPlexSans = IBM_Plex_Sans({
  subsets: ['latin'],
  weight: ['400', '500', '700'],
});

const ResultPage: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState<{
    title: string;
    content: string;
  }>();
  const router = useRouter();
  const screens = useBreakpoint();
  const handleResult = async (slug: string) => {
    try {
      setLoading(true);
      const result = await getResultData(slug);
      setResults(result?.data);
    } catch (error: any) {
      if (error.status === 404) {
        router.replace('/404');
      } else {
        notify(formateErrorObject(error), 'error');
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (router.query.result_slug) {
      handleResult(router.query.result_slug as string);
    }
  }, [router.query.result_slug]);

  return (
    <div className={ibmPlexSans.className}>
      <div className='bg-[#121212] pt-20 pb-10 w-full' id='scroll-container'>
        {loading ? (
          <div className='flex justify-center h-screen items-center'>
            <CustomLoader />
          </div>
        ) : (
          <div className=''>
            <div className='flex justify-center w-full min-h-screen bg-[#121212]'>
              <div className='text-white xl:w-7/12 lg:w-10/12 w-full  xl:px-7 md:px-[70px]  px-[30px]'>
                <Link href='/'>
                  <Button
                    type='text'
                    className='text-base  hover:text-white bg-transparent border-none pl-0  text-[#787878] font-medium  rounded-lg flex items-center gap-2'
                  >
                    <ChevronLeftIcon className='w-5 h-5' /> Back
                  </Button>
                </Link>
                <Renderer
                  data={[
                    {
                      id: 1,
                      type: 'html',
                      value: results?.content as string,
                    },
                  ]}
                />
                <ButtonDefault
                  size={screens.md ? 2 : 1}
                  rounded={false}
                  variant={ButtonVariants.WHITE}
                  enableScaling={false}
                  onClick={() => router.push(`/`)}
                  className='w-full text-center text-sm p-3 '
                >
                  <span className='md:px-1 py-1 font-semibold whitespace-nowrap'>
                    Read a Free Book
                  </span>
                </ButtonDefault>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ResultPage;
